import type { FaireProductEntity } from "../../entity_types/product";

export const p_svbfhypskp: FaireProductEntity = {
  token: "p_svbfhypskp",
  type: "product",
  name: "Maid Of Honor Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8e3758914962aed817451ed86e56d07defe7cf8151043f86e7597ce44edb5f88.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a09b9eff36a159b79732e3c26913c2431469b4b6c9a17ed499121e0a34134455.jpeg",
    "https://cdn.faire.com/fastly/dcbe1e63dde98c323b26ae1fde6760686a20b4f2be6587c893e59347fcc50e65.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/11a79bb2e0a922fb1f4f9122e7d0833961f0dc92df08305d34b0a0d7c9790703.jpeg",
    "https://cdn.faire.com/fastly/e7c598f62985c6da8637bb38b9b3f6d69dfaf09162b1ee3dbc438dcc7c140d19.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the best friend who helped plan the shower, started about 42 group chats, packed the tissues, safety pins, snacks and tampons, and somehow kept everything moving until the big day. A perfect gift for the person who made all the wedding celebrations happen.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:30.784Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
